export default (fn, props) => async dispatch => dispatch(fn(props))
